import { useGetProfiles } from './useGetProfiles';

/**
 * Hook for accessing profiles data within Personnel domain
 *
 * Eliminates prop drilling by accessing profiles data through context.
 * Uses React Query for caching and automatic updates.
 *
 * @returns {Object} Query result with profiles array
 * @returns {Profile[]} returns.data - Array of profiles (empty array if loading/error)
 * @returns {boolean} returns.isLoading - Whether profiles are being fetched
 * @returns {boolean} returns.isError - Whether an error occurred
 * @returns {Error} returns.error - Error object if request failed
 *
 * @example
 * const { data: profiles, isLoading, isError } = usePersonnelProfiles();
 *
 * if (isLoading) return <Spinner />;
 * if (isError) return <ErrorMessage />;
 *
 * return <ProfileSelect options={profiles} />;
 */
export const usePersonnelProfiles = () => {
  return useGetProfiles();
};
